<template>
	<div class="conten">
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true">
				<el-form-item>
					<el-input clearable v-model="secah.newsTitle" placeholder="请输入昵称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button @click='secahClick'>搜索</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click='add'>新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<div>
			<el-table :data="tableData" style="width: 100%" border>
				<el-table-column prop="newsTitle" label="标题" align="center">
				</el-table-column>
				<el-table-column prop="createDate" label="修改时间" align="center">
				</el-table-column>
				<el-table-column prop="newsContent" label="内容" align="center">
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="250" align="center">
					<template slot-scope="scope">
						<el-button size="mini" @click="edit(scope.row)">编辑</el-button>
						<el-button size="mini" type="danger" @click="del(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="page">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page.sync="secah.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="secah.pageSize"
				layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>
		<el-dialog :close-on-click-modal='false' :close-on-press-escape='false' :title="isAdd?'新增':'修改'" :visible.sync="dialogVisible" :modal-append-to-body='false' width="600px">
			<el-form :model="form">
				<el-form-item label="标题" label-width='100px'>
					<el-input v-model="form.newsTitle" maxlength="18" autocomplete="off" placeholder="请输入用户名"></el-input>
				</el-form-item>
				<el-form-item label="内容" label-width='100px'>
					<el-input v-model="form.newsContent" type="textarea"  autocomplete="off" placeholder="请输入昵称"></el-input>
				</el-form-item>
				
				

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="sub">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				roleOptions: [],
				selectTableData: [],
				tableData: [],
				total: 0,
				dialogVisible: false,
				isAdd: true,
				secah: {
					pageSize: 10,
					pageNum: 1,
					newsTitle: ""
				},
				form: {
					"commonNewsId": "",
					"newsContent": "",
					"newsTitle": ""
				},

			}
		},
		created() {
			this.getList()
		},
		methods: {
			//搜索
			secahClick() {
				this.secah.pageNum = 1
				this.getList()
			},
			//新增
			add() {
				this.dialogVisible = true
				this.isAdd = true
				this.form={
					"commonNewsId": "",
					"newsContent": "",
					"newsTitle": ""
				}
			},
			//提交
			sub(){
				if (this.form.newsTitle.length == 0) {
					this.$message('请输入标题');
					return false
				}
				if (this.form.newsContent.length == 0) {
					this.$message('请输入内容');
					return false
				}
				
				var url=this.isAdd?"/commonNews/add":"/commonNews/update"
				if(this.isAdd){
					this.httpPost(url, this.form, true, {
						'Content-Type': 'application/json'
					}).then(res => {
						if (res.code == 200) {
							this.$message.success('新增成功');
							this.dialogVisible = false
							this.getList()
						}
					})
				}else{
					this.httpPut(url, this.form, true, {
						'Content-Type': 'application/json'
					}).then(res => {
						if (res.code == 200) {
							this.$message.success('修改成功');
							this.dialogVisible = false
							this.getList()
						}
					})
				}
				
			},
			
			//删除
			del(row) {
				console.log(row);
				this.$confirm('此操作将永久删除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.httpDel("/commonNews/del?"+this.$qs.stringify({commonNewsId:row.commonNewsId})).then(res => {
						if (res.code == 200) {
							this.$message.success('删除成功');
							this.getList()
						}
					})
				}).catch(() => {
					// this.$message({
					// 	type: 'info',
					// 	message: '已取消删除'
					// });
				});
			},
			//修改
			edit(row) {
				this.dialogVisible = true
				this.isAdd = false
				this.form=JSON.parse(JSON.stringify(row))
				// this.form.password=''
				
			},
			

			//选择分页条数
			handleSizeChange(e) {
				this.secah.pageNum = 1
				this.secah.pageSize = e
				this.getList()
			},
			//页码
			handleCurrentChange(e) {
				this.secah.pageNum = e
				this.getList()
			},
			//获取数据
			getList() {
				this.httpPost("/commonNews/listByPage", this.secah, true, {
					'Content-Type': 'application/json'
				}).then(res => {
					if (res.code == 200) {
						this.tableData = res.data.content
						this.total = res.data.total
					}
				})

			},
			

		},


	}
</script>

<style scoped lang='scss'>
	.page {
		padding: 20px 0;
	}
</style>
